/**
 * 本地业务逻辑错误主动抛出错误附带错误码
 */
export enum EC {
  /** 未知错误 */
  UNKNOWN,
  /** 无法获取 file 在 input 的 change 事件 */
  INVALID_FILE,
}
